import { useLocation, useRoutes } from 'react-router-dom';
import HomePage from '../pages/HomePage/HomePage';
import CategoryTemplate from '../section/CMS/page-templates/CategoryTemplate';
import ApplicationTemplate from '../section/CMS/page-templates/ApplicationTemplate';
import ProductPage from '../section/ProductTemplate/ProductPage';
import WallPaperCalculatorPage from '../pages/WallPaperPage/WallPaperCalculatorPage';
import StoreLocatorPage from '../pages/company/StoreLocatorPage';
import CareerPage from '../pages/company/CareerPage';
import AboutUsPage from '../pages/company/AboutUsPage';
import Navbar from '../components/shared/layout/navbar/Navbar';
import Footer from '../components/shared/layout/footer/Footer';
import CollectionTemplate from '../section/CMS/page-templates/CollectionTemplate';
import BrandsTemplate from '../section/CMS/page-templates/BrandsTemplate';
import BrandsPage from '../pages/Brands/BrandsPage';
import ResponsibilityPage from '../pages/company/ResponsibiltyPage';
import DirectorsPage from '../pages/company/DirectorsPage';
import InternationalsPage from '../section/international/InternationalsPage';
import InternationalBrandPage from '../section/international/InternationalBrandPage';
import RegistrationPage from '../pages/RegistrationPage/RegistrationPage';
import ApplicationTypeTemplate from '../section/CMS/page-templates/ApplicationTypeTemplate';
import ApplicationTypeCategoryTemplate from '../section/CMS/page-templates/src/components/shared/pageTemplates/ApplicationTypeCategoryTemplate';
import CustomPageTemplate from '../section/CMS/page-templates/CustomPageTemplate';


const AppRoutes = () => {
    const routes = [
        { path: '/', element: <HomePage /> },
        {
            path: 'brand',
            element: <BrandsPage />,
        },
        {
            path: 'register',
            element: <RegistrationPage />,
        },
        {
            path: 'item_group/:item_group/brand/:brand',
            element: <BrandsTemplate />,
        },
        {
            path: 'responsibilities',
            element: <ResponsibilityPage />,
        },
        {
            path: 'directors',
            element: <DirectorsPage />,
        },
        { path: 'item_group/:item_group', element: <CategoryTemplate /> },
        {
            path: 'item_group/:item_group/application/:application',
            element: <ApplicationTemplate />,
        },
        {
            path: 'item_group/:item_group/collection/:collection',
            element: <CollectionTemplate />,
        },
        {
            path: 'item_group/:item_group/collection/:collection/design/:design',
            element: <ProductPage />,
        },
        {
            path: 'item_group/:item_group/collection/:collection/design/:design/colour/:colour',
            element: <ProductPage />,
        },
        { path: 'company', element: <StoreLocatorPage /> },
        { path: 'about-us', element: <AboutUsPage /> },
        { path: 'careers', element: <CareerPage /> },
        { path: 'store-locator', element: <StoreLocatorPage /> },
        { path: 'wallpaper-calculator', element: <WallPaperCalculatorPage /> },
        { path: 'internationals', element: <InternationalsPage /> },
        { path: 'internationals/brand/:brandId', element: <InternationalBrandPage /> },
        {
            path: 'item_group/:item_group/application_type/:application_type',
            element: <ApplicationTypeTemplate />,
        },
        {
            path: 'item_group/:item_group/application_type/:application_type/category_name/:category_name',
            element: <ApplicationTypeCategoryTemplate />,
        },
        {
            path: ':slug',
            element: <CustomPageTemplate />,
        },
    ];

    const element = useRoutes([...routes]);
    const location = useLocation();
    const displayNavFooter = location.pathname !== '/register';
    return (
      <>
          {displayNavFooter && <Navbar />}
          {element}
          {displayNavFooter && <Footer />}
      </>
    );
};

export default AppRoutes;